import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/hooks/useAuth";
import { AppErrorBoundary } from "@/components/AppErrorBoundary";
import ComingSoon from "./pages/ComingSoon";
import CookieConsent from "@/components/CookieConsent";

// Lazy load non-critical pages to reduce initial bundle size
const Auth = lazy(() => import("./pages/Auth"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const BookingConfirmation = lazy(() => import("./pages/BookingConfirmation"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 300_000,
    },
  },
});

const App = () => (
  <AppErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <AuthProvider>
          <div className="dark">
            <Toaster />
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<ComingSoon />} />
                <Route path="/auth" element={<Suspense fallback={<div className="min-h-screen bg-background" />}><Auth /></Suspense>} />
                <Route path="/dashboard" element={<Suspense fallback={<div className="min-h-screen bg-background" />}><Dashboard /></Suspense>} />
                <Route path="/booking-confirmed" element={<Suspense fallback={<div className="min-h-screen bg-background" />}><BookingConfirmation /></Suspense>} />
                <Route path="/privacy-policy" element={<Suspense fallback={<div className="min-h-screen bg-background" />}><PrivacyPolicy /></Suspense>} />

                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<ComingSoon />} />
              </Routes>
              <CookieConsent />
            </BrowserRouter>
          </div>
        </AuthProvider>
      </TooltipProvider>
    </QueryClientProvider>
  </AppErrorBoundary>
);

export default App;
